import React, { Component } from "react";
import emptycontentImg from "Assets/images/emptycontent.png";
import platform from "Pub/js/platform";
const { NCButton } = platform.base;

function EmptyContent(props) {
    return (
        <div className="nc-workbench-home-empty">
            <div className="empty-container">
                <div
                    className="empty-img"
                    style={{
                        width: "260px",
                        height: "120px",
                        background: `url(${emptycontentImg}) no-repeat 0px 0px`,
                        backgroundSize: "contain"
                    }}
                />
                <div className="empty-content">{props.contentText}</div>
                <div className="empty-btn">
                    <NCButton
                        className="empty-button"
                        fieldid="addApp"
                        onClick={props.onBtnClick}
                    >
                        {props.btnText}
                    </NCButton>
                </div>
            </div>
        </div>
    );
}
export default EmptyContent;
